import React from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import { RotatingSquare } from "react-loader-spinner";
import "./style.css";
import Marketingsidebar from "@/components/Marketing_bar";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Stats from "./components/Stats";
import Stepper from "./components/Stepper";
import Roadmap from "./components/Roadmap";
import { useLevelRankingState } from "@/hooks/useLevelRankingState";

export default function AgentLevels() {
  const {
    isOpen,
    setIsOpen,
    user,
    selectedShop,
    metrics,
    progression,
    isFetching,
    isInitialLoading,
  } = useLevelRankingState();

  // Full-screen loader on page reload / initial sync
  if (isInitialLoading) {
    return (
      <div className="screenHeight marketing_level_fullscreen_loader">
        <div className="marketing_level_loader_card">
          <RotatingSquare
            height="90"
            width="90"
            color="#267DCF"
            ariaLabel="rotating-square-loading"
            strokeWidth="4"
            visible={true}
          />
          <div className="d-flex align-items-center justify-content-center gap-2 mt-4 mb-2">
            <span className="marketing_level_pulse_dot" />
            <h4
              className="fw-bold text-dark mb-0"
              style={{ letterSpacing: "-0.02em" }}
            >
              Processing
            </h4>
          </div>
          <p className="text-muted small mb-0" style={{ maxWidth: 320 }}>
            Synchronizing your live rank, milestones, and shop progression...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="screenHeight">
      <div className="container-fluid marketing_level_container">
        {/* Fixed-height layout: sidebar + scrollable content */}
        <Row className="g-3 marketing_level_layout">
          {/* Left sidebar — poori height, border bottom tak */}
          <Col
            lg="3"
            xl="3"
            md="4"
            sm="12"
            xs="12"
            className="marketing_level_sidebar_col"
          >
            <div className="bg-white shadow-sm sidebar-border rounded marketing_level_sidebar_box">
              <Marketingsidebar isOpen={isOpen} setIsOpen={setIsOpen} />
            </div>
          </Col>

          {/* Right content — fixed height + apna scroll */}
          <Col
            lg="9"
            xl="9"
            md="8"
            sm="12"
            xs="12"
            className="marketing_level_content_col"
          >
            <div className="marketing_level_scroll shadow rounded position-relative">
              {/* Subtle badge for silent background updates when already viewing */}
              {isFetching && (
                <div
                  className="position-absolute top-0 end-0 m-3 z-3 bg-white px-2.5 py-1 rounded-pill shadow-sm d-flex align-items-center gap-2 border"
                  style={{ fontSize: 11 }}
                >
                  <Spinner animation="border" size="sm" variant="primary" />
                  <span className="text-muted fw-semibold">
                    Updating Live...
                  </span>
                </div>
              )}

              <div className="marketing_level_inner">
                {/* 1. Dynamic User Header */}
                <Header
                  user={user}
                  selectedShop={selectedShop}
                  progression={progression}
                  metrics={metrics}
                />

                {/* 2. Dynamic Progress Hero Banner */}
                <Hero
                  progression={progression}
                  metrics={metrics}
                  selectedShop={selectedShop}
                />

                {/* 3. Stats Overview */}
                <Stats progression={progression} metrics={metrics} />

                {/* 4. 10-Tier Stepper Journey */}
                <Stepper
                  stepper={progression?.stepper}
                  completedLevelsCount={progression?.completedLevelsCount ?? 0}
                />

                {/* 5. Complete 10-Tier Roadmap & Pinnacle */}
                <Roadmap
                  tiers={progression?.tiers}
                  pinnacle={progression?.pinnacle}
                  completedLevelsCount={progression?.completedLevelsCount ?? 0}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}
